export function CircleCommentIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M15.904 19H19v-3.096l.201-.414A7.96 7.96 0 0020 12a8 8 0 10-8 8 7.96 7.96 0 003.49-.799l.414-.201zM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10a9.96 9.96 0 01-1 4.364V21h-4.636c-1.319.64-2.8 1-4.364 1-5.523 0-10-4.477-10-10z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
